import request from '@/config'
import { DepartmentSchema, DepartmentSearch } from './department.type'

/* 部门：查询(LIST) */
export const GetDepListApi = (searchIpt: DepartmentSearch = { page_size: 10, current: 1, tenant_id: 1 }): Promise<IResponse> => {
    return request.post({ url: '/api/SysDepartment/GetSysDepartmentPage', data: searchIpt })
}

/* 部门：获取详细(Detail) */
export const GetDepartmentInfoApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysDepartment/GetSysDepartmentInfo', data: delParams })
}

/* 部门：创建(CREATE) */
export const CreateDepartmentApi = (createIpt: DepartmentSchema): Promise<IResponse> => {
    return request.post({ url: '/api/SysDepartment/InsertSysDepartment', data: createIpt })
}

/* 部门：修改(Modify) */
export const ModifyDepartmentApi = (modifyIpt: DepartmentSchema): Promise<IResponse> => {
    return request.post({ url: '/api/SysDepartment/UpdateSysDepartment', data: modifyIpt })
}

/* 部门：删除(Delete) */
export const DeleteDepApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysDepartment/DeleteSysDepartment', data: delParams })
}

